export default __webpack_public_path__ + "static/media/logoSaltos.0978c312.webp";